import React from 'react';
import styled from 'styled-components';
import { Button } from './ui';
import { CheckCircle } from 'lucide-react';

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  text-align: center;
`;

const SuccessIcon = styled(CheckCircle)`
  color: ${({ theme }) => theme.colors.status.success};
  margin-bottom: 24px;
`;

const SuccessTitle = styled.h2`
  margin-bottom: 16px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 32px;
`;

interface SuccessScreenProps {
  onAddAnother: () => void;
  onGoToWall: () => void;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({ onAddAnother, onGoToWall }) => {
  return (
    <SuccessContainer>
      <SuccessIcon size={64} />
      <SuccessTitle>Ping Sent!</SuccessTitle>
      <p>Your memory has been successfully added to the wall.</p>
      <ButtonGroup>
        <Button onClick={onAddAnother}>Add Another</Button>
        <Button variant="secondary" onClick={onGoToWall}>
          Back to Wall
        </Button>
      </ButtonGroup>
    </SuccessContainer>
  );
};

export default SuccessScreen;
